import _ from 'lodash'

export default (c = {}) => _.cloneDeep(c)